export default __webpack_public_path__ + "heart-shape-outline.png";